<template>
  <div class="c-monitor">
    <!-- filter -->
    <detail-filter :accountData="accountData" :mediaData="mediaData" @on-change="filterData" />
    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <detail-table :loading="loading" :height="tableHeight" :data="tableList" :columns="tableCol" @on-retry="retryDetail" />
        <Page
          show-total
          show-sizer
          show-elevator
          class="c-table-page pager"
          size="small"
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
        />
      </Viewport>
    </div>
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/shutdown_detail_column'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, deepCopy } from '@/common/js/utils'
import { getShutdownDetail, retryShutdownPlanById } from '@/api/manage.model'
import DetailFilter from './components/detail-filter'
import DetailTable from './components/detail-table.vue'
import { adAccount } from '@/api/common.model'

const mediaData = [
  { id: 10, name: '巨量引擎' },
  { id: 16, name: '腾讯' },
  { id: 32, name: '磁力引擎' },
  { id: 45, name: '百度信息流' }
]
export default {
  name: 'shutdowndetail',
  mixins: [mixin],
  components: { DetailFilter, DetailTable },
  data() {
    return {
      tableHeight: 330,
      ruleId: this.$route.query.id,
      accountData: [],
      mediaData
    }
  },
  methods: {
    getData(filter) {
      let params = {
        ruleId: this.ruleId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getShutdownDetail(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    retryDetail(params) {
      const { id } = params
      this.loading = true
      retryShutdownPlanById({ detailId: id })
        .then((data) => {
          this.loading = false
          if (data) this.getData()
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    preloadData() {
      Promise.all([adAccount({ authFlag: 1 })]).then((data) => {
        const [accountData] = data
        if (isArray(accountData)) this.accountData = deepCopy(accountData)
      })
    },
    setLocalPage(size) {
      setLocal('SHUTDOWN_DETAIL_PAGESIZE', size)
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('SHUTDOWN_DETAIL_PAGESIZE')) || 20
    this.tableCol = columns
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
